import { createAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	CreateHotSale,
	CreateHotSalePayload,
	CreateHotSaleQueryParams,
	HotSale,
	HotSaleQueryParams,
} from "../components/type";
import { ApiResponse } from "types";

interface InitialHotSaleState {
	hotSaleList: HotSale[];
	hotSaleTotal: number;
}

const initialState: InitialHotSaleState = {
	hotSaleList: [],
	hotSaleTotal: 0,
};

export const hotSaleSlice = createSlice({
	name: "hotSale",
	initialState,
	reducers: {
		setListHotSale: (state, action) => {
			state.hotSaleList = action.payload.data;
			state.hotSaleTotal = action.payload.total;
		},
		changeStatusHotSale: (state, action) => {
			const { carId, status } = action.payload;
			const findIndex = state.hotSaleList.findIndex(
				item => item.carId === carId,
			);
			if (findIndex !== -1) {
				state.hotSaleList[findIndex].status = status;
			}
		},
		updateHotSaleItemInList: (state, action) => {
			const { carId, startDate, endDate } = action.payload;
			state.hotSaleList = state.hotSaleList.map(item => {
				if (item.carId === carId) {
					return {
						...item,
						startDate: startDate,
						endDate: endDate,
					};
				}
				return item;
			});
		},
	},
});

export const selectHotSaleList = (state: RootState) =>
	state.hotSale.hotSaleList;
export const selectHotSaleTotal = (state: RootState) =>
	state.hotSale.hotSaleTotal;

export const { setListHotSale, changeStatusHotSale, updateHotSaleItemInList } =
	hotSaleSlice.actions;

export interface GetListHotSaleAsyncPayload {
	query: HotSaleQueryParams;
	callback?: () => void;
}

export const getListHotSaleAsync = createAction(
	"hotSale/getListHotSaleAsync",
	(payload: GetListHotSaleAsyncPayload) => ({
		payload: payload,
	}),
);

export interface UpdateStatusHotSaleAsyncPayload {
	carId: number;
	status: string;
	callback: () => void;
}

export const updateStatusHotSaleAsync = createAction(
	"hotSale/updateStatusHotSaleAsync",
	(payload: UpdateStatusHotSaleAsyncPayload) => ({
		payload: payload,
	}),
);

export interface UpdateOrderHotSaleAsyncPayload {
	carId: number;
	newOrder: number;
}

export const updateOrderHotSaleAsync = createAction(
	"hotSale/updateOrderHotSaleAsync",
	(payload: UpdateOrderHotSaleAsyncPayload) => ({
		payload: payload,
	}),
);

export interface UpdateHotSaleAsyncPayload {
	startDate: string;
	endDate: string;
	carId: number;
}

export const updateHotSaleAsync = createAction(
	"hotSale/'updateHotSaleAsync",
	(payload: UpdateHotSaleAsyncPayload) => ({
		payload: payload,
	}),
);

export interface DeleteHotSaleAsyncPayload {
	carId: number;
	callback: () => void;
}

export const deleteHotSaleAsync = createAction(
	"hotSale/deleteHotSaleAsync",
	(payload: DeleteHotSaleAsyncPayload) => ({
		payload,
	}),
);

export interface GetListAvailableHotSaleCarsAsyncPayload {
	query: CreateHotSaleQueryParams;
	callback: (response: ApiResponse<CreateHotSale>) => void;
}

export const getListAvailableHotSaleCarsAsync = createAction(
	"hotSale/getListAvailableHotSaleCarsAsync",
	(payload: GetListAvailableHotSaleCarsAsyncPayload) => ({
		payload,
	}),
);

export interface CreateHotSaleCarsAsyncPayload {
	hotSales: CreateHotSalePayload[];
	callback: () => void;
}

export const createHotSaleCarsAsync = createAction(
	"hotSale/createHotSaleCarsAsync",
	(payload: CreateHotSaleCarsAsyncPayload) => ({
		payload,
	}),
);

export default hotSaleSlice.reducer;
